import { useCallback } from "react";
import { useHistory } from "react-router";
import {
  CompareChangesModalProps,
  CompareContentItem,
} from "src/components/CompareChangesModal/types";
import { FilePreviewById } from "src/components/FileViewer/FilePreviewById";
import { isFileViewable } from "src/components/FileViewer/utils/getFileViewerSource";
import { RefType } from "src/constants/constants";

export type CompareFileActions = Pick<
  CompareChangesModalProps,
  "canPreviewItem" | "renderItemPreview" | "canOpenItem" | "onOpenItem"
>;

const isViewableFile = (item: CompareContentItem) =>
  item.contentRef?.type === RefType.FILE &&
  isFileViewable(item.contentRef.mimetype);

const renderItemPreview = (item: CompareContentItem) =>
  item.contentRef ? <FilePreviewById fileId={item.contentRef.id} /> : null;

/**
 * Preview and "Open in new tab" for file rows in a Compare Changes modal,
 * shared by the Playlist and Channel containers. The new tab opens the media
 * library's own file view.
 */
export const useCompareFileActions = (): CompareFileActions => {
  const history = useHistory();

  const onOpenItem = useCallback(
    (item: CompareContentItem) => {
      if (!item.contentRef) {
        return;
      }
      // createHref applies the router basename (/org/:key for multi-org).
      const href = history.createHref({
        pathname: `/media/${item.contentRef.id}/preview`,
      });
      window.open(href, "_blank", "noopener");
    },
    [history],
  );

  return {
    canPreviewItem: isViewableFile,
    renderItemPreview,
    canOpenItem: isViewableFile,
    onOpenItem,
  };
};
